/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ImmortalFruitsServerDataParser} from "../ImmortalFruitsServerDataParser";
import {IImmortalFruitsInitData} from "./IImmortalFruitsServerData";
import {IBetLineWinData, IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class ImmortalFruitsParsedInitData extends ParsedInitData {
    public get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }
    private _wheelOneValues: number[];
    private _wheelTwoValues: number[];
    private _wheelThreeValues: number[];
    private _totalWheelTimesBetCollected: number;
    private _wheelLevel: number;
    private _LandedWheelIndex: number;
    private _levelPositionsTaken:boolean[];
    private readonly _betWins: IBetLineWinData[] | IBetWayWinData[] | undefined;

    private readonly _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];
    private _accumulatedRoundWin : string;


    constructor(rawData:IImmortalFruitsInitData, dataParser:ImmortalFruitsServerDataParser) {
        super(rawData, dataParser);
        this._wheelOneValues = dataParser.parseWheelOneValues(rawData);
        this._wheelTwoValues = dataParser.parseWheelTwoValues(rawData);
        this._wheelThreeValues = dataParser.parseWheelThreeValues(rawData);
        this._totalWheelTimesBetCollected = dataParser.parseTotalWheelTimesBetCollected(rawData);
        this._wheelLevel = dataParser.parseWheelLevelInit(rawData);
        this._LandedWheelIndex = dataParser.parseLandedWheelIndex(rawData);
        this._levelPositionsTaken = dataParser.parseLevelPositionsTaken(rawData);
        this._betWins = dataParser.parseBetWinsInit((rawData));
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }
    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }
    public get wheelOneValues(): number[] {
        return this._wheelOneValues;
    }
    public get wheelTwoValues(): number[] {
        return this._wheelTwoValues;
    }
    public get wheelThreeValues(): number[] {
        return this._wheelThreeValues;
    }
    public get levelPositionsTaken(): boolean[] {
        return this._levelPositionsTaken;
    }
    public get wheelLevel(): number {
        return this._wheelLevel;
    }
    public get totalWheelTimesBetCollectedAfter(): number {
        return this._totalWheelTimesBetCollected;
    }
    get betWins(): IBetLineWinData[] | IBetWayWinData[] | undefined {
        return this._betWins;
    }
}
